export const wrapper = {
	display: 'block',
};

export const getGoogleMapStyles = (isSmallScreen?: boolean, fullWidth?: boolean) => ({
	height: isSmallScreen ? '18.75rem' : '100%',
	borderRadius: isSmallScreen || fullWidth ? '0' : '0rem 0.5rem 0.5rem 0rem',
});
